<template>
    <div class="root">
        <div class="content">
            <projects />
            <crew/>
        </div>
    </div>
</template>

<script>
import projects from '@/components/projects';
import crew     from '@/components/crew';

export default {
    name: 'myContent',
    components: {
        projects,
        crew,
    }
}
</script>

<style lang="stylus" scoped>

.root {
    position: relative;
}

.content {
    background-image: linear-gradient(120deg,#fdfbfb,#ebedee);
    z-index: 99;
    min-height: 100vh
    padding: 32px;
    margin: 0 auto;
    max-width: 1312px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>